import React from 'react';
import classes from './Heading.module.scss'
import bg from '../../../media/background.svg'
import bg768 from '../../../media/background-768.svg'
import bg1100 from '../../../media/background-1100.svg'
import noise from '../../../media/noise.png'
import arrowIcon from '../../../media/icons/arrow-right-plain.svg'
import {scroller} from "react-scroll";

export interface HeadingProps {
    title: string,
    description: string[],
    buttonText?: string,
    maxWidth?: number
}

// todo use in all Services and Industries

const Heading = ({title, description, buttonText, maxWidth = 815}:HeadingProps) => {
    return (
        <section className={classes.container} id="nav-dark">
            <img alt="" className={classes.background} src={bg}/>
            <img alt="" className={classes['background-768']} src={bg768}/>
            <img alt="" className={classes['background-1100']} src={bg1100}/>
            <img alt="" className={classes.noise} src={noise}/>

            <div className={classes.content}
                 style={{ "--heading-max-width": `${maxWidth}px` } as React.CSSProperties}
            >
                <h1>{title}</h1>
                {description.map((text, i) => <p key={i}>{text}</p>)}
                {!!buttonText && <button onClick={() => scroller.scrollTo("contact", {
                    smooth: true,
                    offset: -50,
                    duration: 800,
                })}><span>{buttonText}</span><img alt="" src={arrowIcon}/></button>}
            </div>
        </section>
    );
};

export default Heading;